<div *ngIf="accessGranted(); else noAccess">
    <div class="body">
        <div style="text-align: center;">
            <mat-form-field class="super-search">
                <mat-label>Produkt suchen</mat-label>
                <input matInput placeholder="Produktnummer, Produktname ..." [matAutocomplete]="auto" [(ngModel)]="productFilter">
                <mat-icon matSuffix>search</mat-icon>
                <mat-autocomplete #auto="matAutocomplete">
                    <div *ngFor="let p of products">
                        <mat-option *ngIf="applyProductFilter(p)">
                            <div (click)="addProductToShoppingCart(p)">
                                {{ p.productnumber }} {{ p.productservice }}
                            </div>
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="content-row">
            <div class="left-col">
                <div class="product-tree">
                    <div class="product-tree-headline">
                        <mat-icon class="icon">router</mat-icon>
                        <span class="text">Produktbaum</span>
                    </div>
                    <app-product-tree [products]="products" (onProductSelect)="addProductToShoppingCart($event)"></app-product-tree>
                </div>
                <div class="suggestion-tile recent">
                    <div class="suggestion-headline">
                        <mat-icon class="suggestion-headline-icon">history</mat-icon>
                        <span class="text">Zuletzt verwendet</span>
                    </div>
                    <div *ngFor="let p of recentProductObjects" class="product-suggestion"
                        (click)="addProductToShoppingCart(p)">
                        <div class="image-wrapper">
                            <img class="preview-image" *ngIf="hasPreviewPicture(p); else placeholderImage"
                                src="{{getPictureDataForProduct(p)}}">
                            <ng-template #placeholderImage>
                                <img class="preview-image" src="{{getPlaceholderImage()}}">
                            </ng-template>
                        </div>
                        <div class="label">
                            <div class="product-headline">{{p.productservice}}</div>
                            <div class="product-subtitle">Produktnummer {{p.productnumber}}</div>
                        </div>
                    </div>
                </div>
                <div class="suggestion-tile most">
                    <div class="suggestion-headline">
                        <mat-icon class="suggestion-headline-icon">star_outline</mat-icon>
                        <span class="text">Häufig verwendet</span>
                    </div>
                    <div *ngFor="let p of mostCommonProductObjects" class="product-suggestion"
                        (click)="addProductToShoppingCart(p)">
                        <div class="image-wrapper">
                            <img class="preview-image" *ngIf="hasPreviewPicture(p); else placeholderImage"
                                src="{{getPictureDataForProduct(p)}}">
                            <ng-template #placeholderImage>
                                <img class="preview-image" src="{{getPlaceholderImage()}}">
                            </ng-template>
                        </div>
                        <div class="label">
                            <div class="product-headline">{{p.productservice}}</div>
                            <div class="product-subtitle">Produktnummer {{p.productnumber}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shopping-cart">
                <div class="shopping-cart-overview">
                    <div *ngIf="shoppingCartItems.length == 0; else shoppingCart" class="no-items">
                        <mat-icon class="icon">shopping_cart</mat-icon>
                        <div class="text">Sie haben keine Artikel im Warenkorb</div>
                    </div>
                    <ng-template #shoppingCart>
                        <div *ngFor="let item of shoppingCartItems; let i = index" class="shopping-cart-item">
                            <div class="image-wrapper big">
                                <span class="index">{{item.itemposition}}</span>
                                <img class="preview-image" *ngIf="hasPreviewPicture(getProductById(item.itemproduct)); else placeholderImage"
                                    src="{{getPictureDataForProduct(getProductById(item.itemproduct))}}">
                                <ng-template #placeholderImage>
                                    <img class="preview-image" src="{{getPlaceholderImage()}}">
                                </ng-template>
                            </div>
                            <div class="label">
                                <div class="label-headline">
                                    <div *ngIf="item.isNew; else persisted" class="headline-badge warning" matTooltip="Dieser Artikel ist nicht auf dem Server gespeichert. Beim Verlassen der Webseite ohne Speichern der Änderungen gehen Daten verloren.">
                                        Neu - ungespeichert
                                    </div>
                                    <ng-template #persisted>
                                        <div *ngIf="item.isChanged; else notChanged" class="headline-badge warning" matTooltip="Dieser Artikel ist auf dem Server gespeichert, enthält aber lokale Änderungen. Beim Verlassen der Webseite ohne Speichern der Änderungen gehen Daten verloren.">
                                            Angelegt - ungespeicherten Änderungen
                                        </div>
                                        <ng-template #notChanged>
                                            <div class="headline-badge success" matTooltip="Dieser Artikel ist auf dem Server gespeichert und enthält keine lokalen Änderungen. Beim Verlassen der Webseite können keine Daten des Artikels verloren gehen.">
                                                Angelegt - keine ungespeicherten Änderungen
                                            </div>
                                        </ng-template>
                                    </ng-template>
                                </div>
                                <mat-form-field class="sixth">
                                    <mat-label>Position</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="Position" 
                                        [value]="item.itemposition" 
                                        (keyup)="setValue(item, 'itemposition', $event.target.value)"
                                    />
                                </mat-form-field>
                                <mat-form-field class="sixth">
                                    <mat-label>Anzahl</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="Anzahl" 
                                        [value]="item.itemcount" 
                                        (keyup)="setValueNumber(item, 'itemcount', $event.target.value)"
                                    />
                                </mat-form-field>
                                <mat-form-field class="f-sixth">
                                    <mat-label>Service Bezeichnung</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="z.B. IP Adresse, Telefonnummer ..."
                                        [value]="item.itemdesc" 
                                        (keyup)="setValue(item, 'itemdesc', $event.target.value)"
                                    />
                                </mat-form-field>
                                <mat-form-field class="width">
                                    <mat-label>Informationen</mat-label>
                                    <textarea 
                                        matInput 
                                        placeholder="z.B. IP Adresse, Telefonnummer ..."
                                        [value]="item.iteminfo" 
                                        (keyup)="setValue(item, 'iteminfo', $event.target.value)"
                                    ></textarea>
                                </mat-form-field>
                                <mat-form-field class="quarter">
                                    <mat-label>Vertrag</mat-label>
                                    <mat-select 
                                        [ngModel]="item.itemcontract" 
                                        (selectionChange)="setValue(item, 'itemcontract', $event.value)"
                                    >
                                        <div *ngFor="let c of contracts">
                                            <mat-option *ngIf="contractMatchesIssueCustomer(c)" [value]="c.contractid">
                                                {{ c.contractnumber }} {{ c.contractdesc }}
                                            </mat-option>
                                        </div>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="quarter">
                                    <mat-label>Einrichtungskosten</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="Kosten" 
                                        [value]="item.itemsetupcost | currency"
                                        (blur)="setValueNumber(item, 'itemsetupcost', $event.target.value)"
                                    />
                                    <mat-icon matPrefix class="prefix">euro_symbol</mat-icon>
                                </mat-form-field>
                                <mat-form-field class="quarter">
                                    <mat-label>Mietkosten</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="Kosten" 
                                        [value]="item.itemrentalcost | currency"
                                        (blur)="setValueNumber(item, 'itemrentalcost', $event.target.value)" 
                                    />
                                    <mat-icon matPrefix class="prefix">euro_symbol</mat-icon>
                                </mat-form-field>
                                <mat-form-field class="quarter">
                                    <mat-label>Kosten bei Kauf</mat-label>
                                    <input 
                                        matInput 
                                        placeholder="Kosten" 
                                        [value]="item.itempurchasecost | currency"
                                        (blur)="setValueNumber(item, 'itempurchasecost', $event.target.value)" 
                                    />
                                    <mat-icon matPrefix class="prefix">euro_symbol</mat-icon>
                                </mat-form-field>
                                <div>
                                    <div class="control success" *ngIf="canSaveItem(item)" (click)="bookItem(item)">
                                        <mat-icon class="icon">save</mat-icon>
                                        <span>Artikel buchen</span>
                                    </div>
                                    <div class="control danger" (click)="removeOfferItem(item)">
                                        <mat-icon class="icon">delete_forever</mat-icon>
                                        <span>Entfernen</span>
                                    </div>
                                    <div class="control default" (click)="duplicateOfferItem(item)">
                                        <mat-icon class="icon">exposure_plus_1</mat-icon>
                                        <span>Duplizieren</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #noAccess>
    <app-deny-access [source]="'shop.component'" [requirements]="requirements"></app-deny-access>
</ng-template>
<div class="cost-sum-panel">
    <div class="monthly">
        <div class="value">{{sumSingular | sumCurrency}}</div>
        <div class="desc">Einmalig</div>
    </div>
    <div>
        <div class="value">{{sumMonthly | sumCurrency}}</div>
        <div class="desc">Monatlich</div>
    </div>
    <div *ngIf="canBookItems(); else createOffer" class="footer-button" (click)="bookItems()">
        Artikel speichern
    </div>
    <ng-template #createOffer>
        <div class="footer-button" (click)="downloadPDF()">
            Angebot erstellen
        </div>
    </ng-template>
</div>